export default __webpack_public_path__ + "static/media/graham.97982943.png";